export default function auth( { next, store } ) {
    if( !store.getters[ 'auth/authenticated' ] ) {
        return next( {
            name: 'login'
        } );
    }

    if( !store.getters[ 'auth/user' ].is_super ) {
        return next( {
            name: 'home'
        } );
    }

    return next();
}
